export enum SurveyErrorType {
    General,
    Question,
    Answer
}